<template>
  <LandingpageCard
    :name="fullName"
    :icon="icon"
    has-action
  >
    <template v-slot:action>
      <SnippetModal
        :landingpage-slug="`liste-${name.toLowerCase()}`"
        landingpage-type="LIST"
        :readable-landingpage="fullName"
        :company-slug="companySlug"
        :company-site-url="companySiteUrl"
      />
    </template>
    <template v-slot:content>
      <div class="design-wrapper hidden-sm-and-down">
        <Leaf
          class="design-elements"
          width="200"
          style="top: -100px; right: -20px; opacity: 0.5"
          fill
        />
      </div>
      <div class="d-flex content">
        <span>
          {{ $t('landingpages.all-in-one-card.question', { name }) }}<br />
          <span v-html="$t('landingpages.all-in-one-card.disclaimer', { fullName })" />
          <span class="hidden-sm-and-down">
            {{ $t('landingpages.all-in-one-card.copy-text', { name }) }}
          </span>
        </span>
      </div>
    </template>
  </LandingpageCard>
</template>

<script>
import Leaf from '@/components/design-elements/leaf.vue'

import LandingpageCard from '../LandingpageCard.vue'
import SnippetModal from '../snippet/index.vue'

export default {
  components: { SnippetModal, LandingpageCard, Leaf },

  props: {
    companySlug: { type: String, default: '' },
    companySiteUrl: { type: String, default: '' },
    name: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
  computed: {
    fullName() {
      return this.$t('landingpages.all-in-one-card.title', { name: this.name })
    },
  },
}
</script>

<style scoped>
.design-wrapper {
  position: relative;
  height: 1px;
}
.design-elements {
  position: absolute;
  z-index: 1;
  pointer-events: none;
}
.content {
  z-index: 2;
  position: relative;
}
</style>
